
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFilter, faInfoCircle, faSearch, faTimes } from '@fortawesome/free-solid-svg-icons'


import moment from 'moment'
import MenuIcon from '@mui/icons-material/Menu'
import React, { Fragment as F, useContext, useEffect, useRef, useState } from 'react'
import Modal from 'react-modal'

import {
  Link,
  useNavigate,
  useParams,

} from "react-router-dom"

import config from 'config'

import {
  BanksCtx,
} from '$src/components/banks'
import {
  PeriodsCtx,
} from '$src/components/periods'
import {
  formatLineitem,
  SchedulesCtx,
} from './'
import {
  appRouter,
  C,
  logg,
  useApiRouter,
} from '$shared'
import { AppCtx } from '$src/App'

library.add( faFilter, faInfoCircle, faSearch, faTimes )



/**
 * DocShow
**/
const DocShow = (props) => {
  // logg(props, 'DocShow')

  const apiRouter = useApiRouter()
  const navigate = useNavigate()

  const params    = useParams()
  // logg(params, 'params')

  useEffect(() => {
    // setParams({ schedule_id: params.schedule_id })
    setActionName("docs#show")
  }, [ params.schedule_id ])


  const {
    actionName, setActionName,
                setParams,
    loading, setLoading,
    loading2, setLoading2,
    userConfig,
  } = useContext(AppCtx)
  // logg(useContext(AppCtx), 'AppCtx in DocShow')

  const {
    resultsTitle, setResultsTitle,
  } = useContext(BanksCtx)
  // logg(useContext(BanksCtx), 'BanksCtx in DocShow')

  const {
    oneResultTitle, setOneResultTitle, defaultOneResultTitle,
  } = useContext(SchedulesCtx)
  // logg(useContext(SchedulesCtx), 'SchedulesCtx in DocShow')

  const {
    selectedPeriods,
    selectedPeriodsReverse,
  } = useContext(PeriodsCtx)
  // logg(useContext(PeriodsCtx), 'useContext(PeriodsCtx)')

  // const [ loading2, setLoading2 ] = useState(false)

  const [ schedule, setSchedule ] = useState({ lineitems: [], periods: [] })
  useEffect(() => {
    setLoading2(true)
    fetch(apiRouter.docsPath(params.schedule_id)
      ).then(r => r.json()).then(inns => {
        logg(inns, 'got Schedule')
        setSchedule(inns)
        setLoading2(false)
      })
  }, [ params.rssd, params.schedule_id, selectedPeriods, selectedPeriodsReverse ])

  useEffect(() => {
    setResultsTitle(null)
    setOneResultTitle(<F>
      Data Dictionary &nbsp;
      <FontAwesomeIcon icon="fa-solid fa-times"
        style={{ cursor: 'pointer' }}
        onClick={() => {
          setOneResultTitle(defaultOneResultTitle)
          navigate('/')
        } }
      />
    </F>)
  }, [])

  const {
    docShowRef,
    schedulesList,
    schedulesOpen, setSchedulesOpen,
  } = useContext(SchedulesCtx)
  // logg(useContext(SchedulesCtx), 'SchedulesCtx in DocShow')

  if (!schedule.lineitems.length) return <F>.^.</F>

  return <F>
    <div className='DocShow' ref={docShowRef} >
      <table className='bordered padded sticky'  >
        <thead>
          <tr>
            <th className='schedule-name' >
              <div className='d-flex' >
                <MenuIcon onClick={() => setSchedulesOpen(schedulesOpen === C.classes.sidebarIsOpen ? C.classes.sidebarIsClosed : C.classes.sidebarIsOpen) } />
                <div className='flex-grow-1 text-center' >{ schedulesList.filter(item => item.value === params.schedule_id)[0]?.label }</div>
              </div>
            </th>
            <th >Line Item Code</th>
            <th >Definition</th>
          </tr>

        </thead>
        <tbody>

          { schedule.lineitems.map((item, idx) => <tr key={idx} >
            <th className={`${'H3' === item.ubpr_code ? 'header' : '' }`} >
              <div className='tableW' >
                <div className='one' >{item.Row}</div>
                <div className='two align-left' >
                  { ['BR', 'H3'].indexOf(item.ubpr_code) === -1 && item.Friendly_Name }
                  { 'H3' === item.ubpr_code && item.Schedule_UBPR_Code_Label }
                </div>
              </div>
            </th>
            { ['BR', 'H3'].indexOf(item.ubpr_code) === -1 && <F>
              <td className='doc-ubpr-code' >{ item.ubpr_code }</td>
              <td className='doc-definition' >{ item.definition }</td>
            </F> }
          </tr> )}

        </tbody>
      </table>
    </div>
  </F>
}
export default DocShow

